import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import NotFound from "./components/NotFound";
import EmployeePage from "./components/EmployeesPage";
import HomePage from "./pages/HomePage";
import ActivatePage from "./pages/ActivatePage";
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import PinloginPage from "./pages/PinloginPage";


const App = () => {
	return (
		<>
			<Router>
				<Header />
				<main className="py-3">
					<Routes>
						<Route path="/employees" element={<EmployeePage />}/> 
            			<Route path="/"element={<HomePage />}/>
						<Route path="/login" element={<LoginPage />} />
						<Route path="/pinlogin" element={<PinloginPage />} />
						<Route path="/register" element={<RegisterPage />} />
						<Route
							path="/activate/:uid/:token"
							element={<ActivatePage />}
						/>
						<Route path="*" element={<NotFound />}/>
					</Routes>
					<ToastContainer theme="dark" />
				</main>
				<Footer />
			</Router>
		</>
	);
};

export default App;